import { render, staticRenderFns } from "./FeePaymentCard.vue?vue&type=template&id=bc37e472"
import script from "./FeePaymentCard.vue?vue&type=script&lang=js"
export * from "./FeePaymentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports